import React, { useContext, useEffect, useMemo } from 'react';

import { SnackbarContext, SnackbarVariant } from '@eas/common-web';
import { useHistory, useLocation } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import { usePaymentStatus } from './payment-status-hook';
import { DialogContentProps } from '../../../../components/dialog/types';
import { DefaultDialog } from '../../../../components/dialog/vpuk-dialog/vpuk-default-dialog';
import { useInterval } from '../../../../hooks/use-interval';
import { resolvePayment } from './payment-status-api';
import { FormattedMessage, useIntl } from 'react-intl';

interface InitialValues {
  paymentLink: string;
  paymentNumber: number;
}

const useStyles = makeStyles(() => ({
  icon: {
    color: 'green',
  },
  text: {
    maxWidth: '400px',
  },
}));

export function PaymentStatusDialogContent({
  initialValues,
}: DialogContentProps<InitialValues>) {
  const { status, fetchStatus } = usePaymentStatus(
    initialValues!.paymentNumber
  );
  const { showSnackbar } = useContext(SnackbarContext);
  const intl = useIntl();
  const { push, go } = useHistory();
  const location = useLocation();
  const classes = useStyles();

  const isCaptured = useMemo(() => status === 'CAPTURED', [status]);

  useInterval(
    fetchStatus,
    isCaptured ? null : 2000,
    isCaptured ? undefined : 6000
  );

  useEffect(() => {
    if (isCaptured) {
      showSnackbar(
        intl.formatMessage({ id: 'VPUK__NEW_CARD__PAYMENT__SUCCESS' }),
        SnackbarVariant.SUCCESS
      );
      try {
        resolvePayment(initialValues!.paymentNumber.toString());
        // if (res) {
        // }
        // eslint-disable-next-line no-empty
      } catch (err) {}
    }
  }, [initialValues, intl, isCaptured, showSnackbar]);

  const handleBeforeClose = () => {
    if (location.pathname === '/portal/prukazy') go(0);
    else push('/portal/prukazy');
  };

  return (
    <DefaultDialog
      title="Dokončení platby"
      beforeClose={isCaptured ? handleBeforeClose : undefined}
      actions={
        !isCaptured && (
          <Button
            component="a"
            href={initialValues!.paymentLink}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="VPUK__NEW_CARD__PAYMENT__REDIRECT" />
          </Button>
        )
      }
    >
      {isCaptured ? (
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <CheckCircleOutlineIcon className={classes.icon} />
          </Grid>
          <Grid item className={classes.text}>
            <FormattedMessage id="VPUK__NEW_CARD__PAYMENT__SUCCESS_LONG" />
          </Grid>
        </Grid>
      ) : (
        <>
          <p>
            <FormattedMessage id="VPUK__NEW_CARD__PAYMENT__UNFINISHED" />
          </p>
          <LinearProgress />
        </>
      )}
    </DefaultDialog>
  );
}
